export default __webpack_public_path__ + "static/media/ldo_FLOAT_ADJ_EN_Cff.8dd1a536.svg";